module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor06-54a89af6e0ed0391e9ffbed06f33280e.png";